import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, NavParams, Platform } from '@ionic/angular';

import { isUndefined } from 'src/app/services/codeUtils';
import { PASSWORD_PATTERN, mustBeTruthy, EMAIL_PATTERN } from 'src/app/services/customFormValidators';

import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { MarketingService } from 'src/app/services/marketing/marketing.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ProgressingComponent } from 'src/app/components/progressing/progressing.component';
import { EventsService } from 'src/app/services/event/event.service';

@Component({
  selector: 'app-signup-step-one',
  templateUrl: './signup-step-one.component.html',
  styleUrls: ['./signup-step-one.component.scss'],
})
export class SignupStepOneComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;

  public connectBoydCardPath: boolean = false;
  public customer: CustomerModel;
  public termsSingupLinkTitle;
  public bonusCode;
  public stateName: string = this.configService.getState() ?? 'Stardust';
  public error = null;
  public infoForm: FormGroup;
  public emailGroup: AbstractControl;
  public email: AbstractControl;
  public password: AbstractControl;
  public passwordConfirm: AbstractControl;
  public certOver18: AbstractControl;
  public agreeAllTC: AbstractControl;
  public csrf_token: string = '';
  public registrationSuccessful: boolean = false;
  public buttonDisabled: boolean = false;
  public bonusIsVerified: boolean = false;
  public selectedBonusIndex;
  public showPassword: boolean;
  public showConfirmPassword: boolean;
  public showBackButton: boolean = true;
  public customerAttributionData: any[];
  public extAffiliateId: string;
  public verifiedInputBonusCode: string;
  public welcomeOffers = [];
  public allowPromoEmailsCheck: boolean;
  public behalfSignupCheck: boolean;
  public allowPromoEmails: AbstractControl;
  public behalf: AbstractControl;
  public legalAge: number;
  public agreementProcess: boolean = true;
  public agreedCondition: boolean = false;
  public isPlayerLoggedInAsGuest: boolean = false;
  public isExtCustId: boolean = false;
  public fetchEmailFromResponseForSignup: string;
  public featurePrivacyURL: string;
  public featureTermsAndConditionURL: string;
  public isIosWeb: boolean = false;
  constructor(
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private navigator: Navigator,
    private successMessageService: SuccessMessageService,
    private userSessionService: UserSessionService,
    private marketingService: MarketingService,
    private utilsService: UtilsService,
    private loginService: LoginService,
    private appLinks: AppLinksService,
    private eventsService: EventsService,
    private boydRewardsService: BoydRewardsService,
    private appStorageService: AppstorageTsService,
    private navParams: NavParams,
    private platform: Platform
  ) {
    if (this.navParams.data.connectBoydCardPath) {
      this.showBackButton = false;
    }
  }


  ngOnInit() {
    this.appStorageService.getPlayerAsGuest().then((isGuest) => {
      if (isGuest.value === 'true') return this.isPlayerLoggedInAsGuest = true;
      return this.isPlayerLoggedInAsGuest = false;
    })
    this.connectBoydCardPath = this.navParams.data.connectBoydCardPath;

    this.userSessionService.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
        this.isExtCustId = isUndefined(customer.extCustId)
      }
    });

    this.fetchEmailFromResponseForSignup = this.navParams.data.fetchEmailFromResponseForSignup

    this.infoForm = new FormGroup({
      clientapp: new FormControl(''),
      emailGroup: new FormGroup({
        email: new FormControl(this.fetchEmailFromResponseForSignup ? this.fetchEmailFromResponseForSignup : '', [Validators.pattern(EMAIL_PATTERN), Validators.required, Validators.maxLength(250)])
      }),
      password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
      csrf: new FormControl(),
      certOver18: new FormControl(false, [mustBeTruthy]),
    }
    );

    this.infoForm.get("clientapp").setValue(this.configService.getClientApp());

    this.emailGroup = this.infoForm.get('emailGroup');
    this.email = this.emailGroup.get('email');

    this.password = this.infoForm.get('password');
    this.certOver18 = this.infoForm.get('certOver18');

    this.featureTermsAndConditionURL = this.configService.getConfig().FEATURE_SITE_TERMS_LINK;
    this.featurePrivacyURL = this.configService.getConfig().FEATURE_SITE_PRIVACY_LINK;
    this.isIosWeb = this.platform.is("ios") && this.platform.is("mobileweb");
  }


  onFocus() {
    this.scrolltitle(50);
  }

  onBlur() {
    this.scrolltitle(0);
  }

  scrolltitle(scrollLength) {
    if (!this.platform.is('capacitor') && this.platform.is('mobile')) {
      if (!(window.innerWidth < window.innerHeight)) {
        setTimeout(function () {
          window.scrollTo(0, scrollLength);
        }, 300);
      }
    }
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.generateCSRFToken();
  }

  generateCSRFToken() {
    this.authenticationService.getCsrfToken().subscribe((response) => {
      if (!!response.payload && !!response.payload.token) {
        this.csrf_token = response.payload.token;
      }
    });
  }

  guestPlayerEmailProcess() {
    const apiCall$ = this.authenticationService.callGuestAccountEmailUpgrade(this.infoForm.value);
    this.progressingUI.listenObservable(apiCall$);
    apiCall$.subscribe((response: any) => {
      if (response && !!response.result) {
        this.userSessionService.refreshCustomer();
        this.appStorageService.setPlayerAsGuest(false);
        this.loginService.setCustomerID(response.payload?.customerId || response.customerId);
        // this.navigateToAccountCreated(true, undefined);
        this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { emailAccountCreatedFlag: true })
      } else {
        this.registrationSuccessful = false;
      }
      this.buttonDisabled = false;
    },
      (error) => {
        this.generateCSRFToken();
        console.error("callGuestAccountEmailUpgrade error = ", error);
        this.content.scrollToTop(10);
        this.handleError(error)
        this.error = error;
        this.buttonDisabled = false;
      })
  }

  public onSubmit() {
    this.buttonDisabled = true;
    if (this.isPlayerLoggedInAsGuest) {
      if (this.connectBoydCardPath) {
        //User is Guest player and trying to Upgrade/singup with Boyd Connect
        this.guestPlayerBoydCardConnectProcess();
      } else {
        //user is already have guest account and trying to upgrade with email option
        this.guestPlayerEmailProcess();
      }
    } else {
      //User is not Guest player and trying to Upgrade/singup with Boyd Connect
      //OR
      //just simply trying singup with email at first launch
      if (this.connectBoydCardPath) {
        //User is not Guest player and trying to Upgrade/singup with Boyd Connect
        this.guestPlayerBoydCardConnectProcess();
      } else {
        //user don't have any information and choose to singup with Email option and also don't have boyd reward card information
        this.defaultAppLaunchActionProcess();
      }
    }
  }

  guestPlayerBoydCardConnectProcess() {

    let obj: any = {
      clientapp: this.configService.getClientApp(),
      csrf: this.csrf_token,
      reward_number: this.navParams.data.boydCardCustomerDataObj.reward_number,
      lastName: this.navParams.data.boydCardCustomerDataObj.lastName,
      birthDate: this.navParams.data.boydCardCustomerDataObj.birthDate,
      email: this.emailGroup.value["email"],
      password: this.infoForm.value["password"],
      certOver18: true,
    }

    //If Guest user then pass session_token otherwise, fresh user - no platform ID information then send signup param
    if (this.userSessionService.sessionToken) {
      obj.session_token = this.userSessionService.sessionToken
    } else {
      obj.signup = true
    }

    const apiCall$ = this.boydRewardsService.callExternalConnect(obj);
    this.progressingUI.listenObservable(apiCall$);
    apiCall$.subscribe(
      (response: any) => {
        if (response && !!response.result) {

          if (response.payload.sessionToken) {
            this.userSessionService.setSessionToken(response.payload.sessionToken);
          }
          this.boydRewardsService.connectBoydCardToStardust();
          this.appStorageService.setPlayerAsGuest(false);
          if (response.payload.platformId) {
            this.appStorageService.setPlayerPlatformID(response.payload.platformId);
          }
          this.userSessionService.refreshCustomer().subscribe(() => {
            this.eventsService.publish('event:appInit:init');
          });
          this.loginService.setCustomerID(response.payload.customerId);
          this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { boydRewardConnectFlag: true });
          this.buttonDisabled = false;
        }
      },
      (error) => {
        this.generateCsrfToken();
        this.error = error;
        switch (error.getErrorCode().toUpperCase()) {
          case 'CUSTOMER_NOT_FOUND':
            error.setErrorMessage('Customer cannot be found');
            break;
          case 'CARD_ALREADY_EXISTS':
            error.setErrorMessage('Rewards Card already exists');
            break;
          case 'CUSTOMER_EXCLUDED_BY_AUTHORITY':
            error.setErrorMessage("Unfortunately, there is an error - you can’t play on this site.");
            break;
          default:
            error.setErrorMessage('Oops! We cannot confirm your account information');
            break;
        }
        this.buttonDisabled = false;
      }
    );
  }

  defaultAppLaunchActionProcess() {
    let newPlayerData: any = {
      csrf: this.csrf_token,
      email: this.emailGroup.value["email"],
      password: this.infoForm.value["password"]
    }
    const apiCall$ = this.authenticationService.callNewAccountSignupWithEmail(newPlayerData);
    this.progressingUI.listenObservable(apiCall$);
    apiCall$.subscribe(
      (response) => {
        if (!isUndefined(response.payload)) {
          this.appStorageService.setPlayerPlatformID(response.payload.platformId);
          let storeServerCSRFToken = response.payload.csrf_token;
          let loginData: any = {
            csrf: storeServerCSRFToken,
            username: this.emailGroup.value["email"],
            password: this.infoForm.value["password"]
          }
          this.authenticationService.callNewLogin(loginData).subscribe(
            (response) => {
              if (!isUndefined(response.payload)) {
                this.loginService.setCustomerID(response.payload.customerId);
                this.appStorageService.setPlayerPlatformID(response.payload.platformId);
                this.appStorageService.setPlayerAsGuest(false);
                this.userSessionService.setSessionToken(response.payload.sessionToken);
                this.userSessionService.refreshCustomer().subscribe(() => {
                  this.eventsService.publish('event:appInit:init');
                });
                // this.navigateToAccountCreated(true);
                this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { emailAccountCreatedFlag: true });

              }
              this.buttonDisabled = false;
            },
            (error) => {
              this.generateCSRFToken();
              console.error("callGuestAccountEmailUpgrade error = ", error);
              this.content.scrollToTop(10);
              this.handleError(error)
              this.error = error;
              this.buttonDisabled = false;
            }
          )
        } else {
          this.buttonDisabled = false;
        }
      },
      (error) => {
        this.generateCSRFToken();
        console.error("callNewAccountConnectWithBoydRewards error = ", error);
        this.content.scrollToTop(10);
        this.handleError(error)
        this.error = error;
        this.buttonDisabled = false;
      }
    )
  }

  handleError(error: any) {
    switch (error.getErrorCode().toUpperCase()) {
      case 'EMAIL_ALREADY_EXISTS':
        error.setErrorMessage('Form has errors, please see below.');
        this.email.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
        this.emailGroup.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
        this.emailGroup.markAsTouched();
        this.emailGroup.markAsDirty();
        break;
      case 'ALREADY_HAS_ACCOUNT':
        error.setErrorMessage('It appears this account has already been created.');
        break;
      case 'CUSTOMER_IN_BLACKLIST':
        error.setErrorMessage('Cannot create account please contact customer support.');
        break;
      case 'GOVERNMENT_ID_ALREADY_EXISTS':
        error.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
        break;
      default:
        error.setErrorMessage("Something went wrong. Please try again or contact customer support.");
        break;
    }
  }

  generateCsrfToken() {
    this.authenticationService.getCsrfToken().subscribe(
      (response) => {
        if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
          this.csrf_token = response.payload.token;
        }
      }
    );
  }

  protected goToLink(url: string): any {
    return this.appLinks.openExternalPage(url);
  }

  protected hidePassword(): boolean {
    this.showPassword = false;
    return;
  }

  protected unhidePassword(): boolean {
    this.showPassword = true;
    return;
  }

  protected hideConfirmPassword(): boolean {
    this.showConfirmPassword = false;
    return;
  }

  protected unhideConfirmPassword(): boolean {
    this.showConfirmPassword = true;
    return;
  }

  public updateAffiliateData(customer_id: string) {
    // get affiliate data
    this.marketingService.getAttributionData().then(data => {
      var customerUpdates: any = {};
      if (!data) {
        // look for appnexus data
        let appnexus_data: any = null;
        try {
          appnexus_data = JSON.parse(this.marketingService.getAppnexusData());
        } catch (e) {
        }
        if (!!appnexus_data && "undefined" !== typeof appnexus_data.extaffiliateid) {
          customerUpdates['extAffiliateId'] = appnexus_data.extaffiliateid;
        }
        if (!!appnexus_data) {
          customerUpdates['customerAttributionData'] = JSON.stringify(appnexus_data);
        } else {
          delete customerUpdates['customerAttributionData'];
        }
      }
      if (data) {
        try {
          if (typeof data === 'string') {
            data = JSON.parse(data);
          }

          this.customerAttributionData = data;

          if ("undefined" !== typeof data.affid) {
            this.extAffiliateId = data.affid;
          }

          if ("undefined" !== typeof data.affiliate) {
            this.extAffiliateId = data.affiliate;
          }
          if ("undefined" !== typeof data.ext_affiliate_id) {
            this.extAffiliateId = data.ext_affiliate_id;
          }

          if (this.utilsService.getInsensitiveProp(data, 'extAffiliateId')) {
            this.extAffiliateId = this.utilsService.getInsensitiveProp(data, 'extAffiliateId');
          }
        } catch (err) {

        }
        if ("undefined" !== typeof this.extAffiliateId) {
          customerUpdates['extAffiliateId'] = this.extAffiliateId;
        }
        if ("undefined" !== typeof this.customerAttributionData) {
          customerUpdates['customerAttributionData'] = JSON.stringify(this.customerAttributionData);
        }
      }
      const countKeys = (myobj) => {
        var count = 0;
        for (var k in myobj) if (myobj.hasOwnProperty(k)) count++;
        return count;
      }
      if (countKeys(customerUpdates) > 0) {
        this.userSessionService.updateAccount(customer_id, customerUpdates);
      }
    });
  }

  protected onLogin() {
    return this.navigator.navigateTo('LoginComponent');
  }

  private navigateToAccountCreated(flag?: any, boydFlag?: boolean): any {
    console.log('Flag - ' + flag + ' Boyd Flag: ' + boydFlag);

    if (flag) return this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { emailAccountCreatedFlag: flag });
    if (flag === undefined && boydFlag) return this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { boydRewardConnectFlag: boydFlag });
  }

}
